import React, { useState, useEffect } from 'react';
import { getToken } from '../utils/authStorage';
import './ActivityBanner.css';

const ActivityBanner = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
    // Refresh stats every 30 seconds
    const interval = setInterval(loadStats, 30000);
    return () => clearInterval(interval);
  }, []);

  const loadStats = async () => {
    try {
      const token = getToken();
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:9090/api'}/activity/stats/global`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        setStats(data);
      }
      setLoading(false);
    } catch (err) {
      console.error('Failed to load activity stats:', err);
      setLoading(false);
    }
  };

  if (loading || !stats) return null;

  return (
    <div className="activity-banner">
      <div className="activity-stat">
        <div className="stat-icon online">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
            <circle cx="12" cy="12" r="3" fill="currentColor"/>
          </svg>
        </div>
        <span className="stat-value">{stats.membersOnline}</span>
        <span className="stat-label">online now</span>
      </div>

      {stats.messagesToday > 0 && (
        <div className="activity-stat">
          <div className="stat-icon messages">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H5C4.46957 17 3.96086 16.7893 3.58579 16.4142C3.21071 16.0391 3 15.5304 3 15V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H19C19.5304 6 20.0391 6.21071 20.4142 6.58579C20.7893 6.96086 21 7.46957 21 8V15Z" stroke="currentColor" strokeWidth="2"/>
              <path d="M3 8L12 13L21 8" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </div>
          <span className="stat-value">{stats.messagesToday}</span>
          <span className="stat-label">messages today</span>
        </div>
      )}

      {stats.newMembersToday > 0 && (
        <div className="activity-stat">
          <div className="stat-icon new">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <circle cx="8.5" cy="7" r="4" stroke="currentColor" strokeWidth="2"/>
              <path d="M20 8V14M17 11H23" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div>
          <span className="stat-value">{stats.newMembersToday}</span>
          <span className="stat-label">joined today</span>
        </div>
      )}
    </div>
  );
};

export default ActivityBanner;
